import { getRegisterFunction } from '../../utils/register.js';
import { OneUxTabsPreviewElement } from './OneUxTabsPreviewElement.js';
export const register = getRegisterFunction(OneUxTabsPreviewElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-tabs-preview': OneUxTabsPreviewElement;
    "tabs-preview-3c4388ddb9f3bbaaf3b963ee4d896cd7": OneUxTabsPreviewElement;
  }
}